import type { TourConfig } from './types';

export const dashboardTour: TourConfig = {
  id: 'dashboard-overview',
  name: 'Dashboard Overview',
  description: 'Learn about your dashboard and key metrics',
  autoStart: true,
  requiredPath: '/dashboard',
  steps: [
    {
      element: '[data-tour="welcome-heading"]',
      popover: {
        title: 'Welcome to NutriCRM',
        description:
          'This is your dashboard where you can see an overview of your practice at a glance.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="quick-actions"]',
      popover: {
        title: 'Quick Actions',
        description:
          'Use these buttons to quickly add a new lead or create a diet plan.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="quick-stats"]',
      popover: {
        title: 'Your Key Metrics',
        description:
          'Track your active clients, new leads, pending diet plans, and conversion rate here.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="my-clients"]',
      popover: {
        title: 'Your Clients',
        description:
          'See your active clients and their recent activity at a quick glance.',
        side: 'top',
        align: 'center',
      },
    },
    {
      element: '[data-tour="new-leads"]',
      popover: {
        title: 'New Leads',
        description:
          'Keep track of your newest leads and convert them to clients when ready.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
